export default "__VITE_ASSET__B8zRE$qG__"